import {
  generateQueryString,
  requestVehicleSearchCount,
} from '@lib/requests/vehicleSearchCount';
import { devConsoleError } from '@lib/logger';

import {
  ResponseData,
  SnakeCasedFilters,
} from '@javascript/types/SeoPageTypes';

const initHeaderTrimCount = () => {
  class VehicleSearchCounter {
    private makeInput: HTMLInputElement;
    private maxPriceSelect: HTMLSelectElement;
    private minPriceSelect: HTMLSelectElement;
    private modelInput: HTMLInputElement;
    private searchCta: HTMLButtonElement;
    private searchCtaDefaultText: string;
    private trimSelect: HTMLSelectElement;

    // eslint-disable-next-line @typescript-eslint/member-ordering
    private distanceInput?: HTMLInputElement;
    private locationInput?: HTMLInputElement;

    constructor() {
      this.makeInput = document.getElementById('make') as HTMLInputElement;
      this.modelInput = document.getElementById('model') as HTMLInputElement;
      this.trimSelect = document.getElementById('trim') as HTMLSelectElement;
      this.minPriceSelect = document.getElementById(
        'min_price',
      ) as HTMLSelectElement;
      this.maxPriceSelect = document.getElementById(
        'max_price',
      ) as HTMLSelectElement;

      this.searchCta = document.getElementById(
        'search-cta',
      ) as HTMLButtonElement;
      this.searchCtaDefaultText =
        this.searchCta.textContent || 'Search our cars';

      this.locationInput = document.getElementById(
        'location',
      ) as HTMLInputElement;
      this.distanceInput = document.getElementById(
        'distance',
      ) as HTMLInputElement;

      this.initEventListerners();
    }

    private getTrimCount = async (): Promise<ResponseData> => {
      const filters: SnakeCasedFilters = {
        count_only: true,
        make: this.makeInput.value,
        max_price: this.maxPriceSelect.value,
        min_price: this.minPriceSelect.value,
        model: this.modelInput.value,
        sort_order: 'price_up',
        trim: this.trimSelect.value,
        unreserved_only: true,
        ...(this.distanceInput?.value && {
          distance: this.distanceInput.value,
        }),
        ...(this.locationInput?.value && {
          location: this.locationInput.value,
        }),
      };

      const queryString = generateQueryString({ ...filters });
      const response = await requestVehicleSearchCount(queryString);

      if (!response || typeof response.count !== 'number') {
        throw new Error('Invalid API response: Expected { count: number }');
      }

      return response;
    };

    private initEventListerners = (): void => {
      const onFilterChange = this.updateSearchCta.bind(this);

      [this.trimSelect, this.minPriceSelect, this.maxPriceSelect].forEach(
        (select) => {
          select.addEventListener('change', onFilterChange);
        },
      );
    };

    private updateSearchCta = async (): Promise<void> => {
      this.searchCta.classList.add('ch-btn--loading');

      try {
        const { count } = await this.getTrimCount();
        this.searchCta.textContent = `Search ${count} ${
          count === 1 ? 'car' : 'cars'
        }`;
      } catch (error) {
        devConsoleError(error);
        this.searchCta.textContent = this.searchCtaDefaultText;
      }
      this.searchCta.classList.remove('ch-btn--loading');
    };
  }

  return new VehicleSearchCounter();
};

export default initHeaderTrimCount;
